export const setInformativeModal = (text, header) => {
    return {
        type: "SET_INFORMATIVE_MODAL",
        payload: {
            text: text,
            header: header
        }
    }
};
